import React from 'react'
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import CodriverContent from './codrivercontent/codriverContent';
// import CreditContent from './creditscontent/creditsContent';
// import DocumentUploadContent from "./uploadcontent/documentuploadcontent";
import Footer from "../../components/footer";

const codriver = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeader title="Co driver " />
    <CodriverContent />
    <Footer />
    </div>
  )
}

export default codriver